import { FileInfo } from 'app/core/models';
import { AttachOrderFileModel } from './model';

export function parseFileModelFromFileInfo(value: FileInfo): AttachOrderFileModel {
  return {
    id: value.id,
    name: value.name,
    size: value.size,
    fileType: value.fileType,
    fileKind: value.fileKind,
    uploaded: true,
    fileInfo: value,
    uploading: false,
  };
}
